import React, { useState } from 'react';
import AccountLayout from '../components/account/AccountLayout';
import { useAccountCounts } from '../components/account/useAccountCounts';
import AppearanceSettings from '../components/common/AppearanceSettings';
import Button from '../components/common/Button';
import ChangePasswordModal from '../components/Auth/ChangePasswordModal';
import UpdateUserInfoModal from '../components/Auth/UpdateUserInfoModal';
import { useAuth } from '../hooks/useAuth';
import './ProfileSettings.css';

const ProfileSettings: React.FC = () => {
  const { data } = useAccountCounts();
  const { user } = useAuth();
  const [editing, setEditing] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const nickname = (user?.nickname || user?.profile?.nickname || user?.username || '').trim();
  const rows: [string, string | undefined][] = [
    ['Nickname', nickname],
    ['Username', user?.username],
    ['Email', user?.email],
    ['First name', user?.profile?.firstName],
    ['Last name', user?.profile?.lastName],
  ];

  return (
    <AccountLayout title="Settings" data={data}>
      <section className="account-settings__group" data-tour="settings-profile">
        <h2>Profile</h2>
        <dl className="account-settings__rows">
          {rows.map(([label, value]) => (
            <div key={label}><dt>{label}</dt><dd>{value || '—'}</dd></div>
          ))}
        </dl>
        <Button variant="outline" size="sm" onClick={() => setEditing(true)}>Edit</Button>
      </section>
      <section className="account-settings__group" data-tour="settings-security">
        <h2>Security</h2>
        <Button variant="outline" size="sm" onClick={() => setChangingPassword(true)}>Change password</Button>
      </section>
      <section className="account-settings__group" data-tour="settings-appearance">
        <h2>Appearance</h2>
        <AppearanceSettings showHeading={false} />
      </section>
      <UpdateUserInfoModal isOpen={editing} onClose={() => setEditing(false)} />
      <ChangePasswordModal isOpen={changingPassword} onClose={() => setChangingPassword(false)} />
    </AccountLayout>
  );
};

export default ProfileSettings;
